import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';

interface EventMarkerProps {
    event: any;
    lat: number;
    lng: number;
}

const Danger = '/assets/icons/orders/issues/danger.svg'
const Success = '/assets/icons/orders/issues/success.svg'

export const EventMarker: React.FC<EventMarkerProps> = ({ event }: any) => {
    const [isClicked, setIsClicked] = useState(false);
    const ref = useRef<any>();

    useEffect(() => {
        const handleClickOutside = (event: any) => {
            if (ref.current && !ref.current.contains(event.target)) {
                setIsClicked(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const formatString = (str: string): string => {
        let result = str.replace(/_/g, ' '); // replace underscores with spaces
        result = result.charAt(0).toUpperCase() + result.slice(1); // capitalize the first character
        if (result.includes("rfid")) { // convert "rfid" to "RFID"
            result = result.replace(/rfid/g, "RFID");
        }
        return result;
    }

    return (
        <div ref={ref} onClick={() => setIsClicked(!isClicked)}>
            <svg width="36" height="41" viewBox="0 0 36 41" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ transform: "translate(-50%,-70%)" }}>
                <g filter="url(#filter0_d_30_5356)">
                    <path d="M17.9275 5.68048C13.2406 5.68048 9 9.27381 9 14.8312C9 18.3799 11.7341 22.5535 17.191 27.3632C17.6151 27.7315 18.2512 27.7315 18.6752 27.3632C24.121 22.5535 26.8551 18.3799 26.8551 14.8312C26.8551 9.27381 22.6145 5.68048 17.9275 5.68048Z" fill="#FF3B45" />
                    <path d="M17.9284 20.1877C17.3147 20.1877 16.8125 19.6856 16.8125 19.0718C16.8125 18.458 17.3147 17.9558 17.9284 17.9558C18.5422 17.9558 19.0444 18.458 19.0444 19.0718C19.0444 19.6856 18.5422 20.1877 17.9284 20.1877Z" fill="white" />
                    <path d="M17.9284 15.724C17.3147 15.724 16.8125 15.2218 16.8125 14.608V11.2602C16.8125 10.6464 17.3147 10.1443 17.9284 10.1443C18.5422 10.1443 19.0444 10.6464 19.0444 11.2602V14.608C19.0444 15.2218 18.5422 15.724 17.9284 15.724Z" fill="white" />
                </g>
                <defs>
                    <filter id="filter0_d_30_5356" x="0" y="0.680481" width="35.8555" height="39.959" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix" />
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                        <feOffset dy="4" />
                        <feGaussianBlur stdDeviation="4.5" />
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0" />
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_30_5356" />
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_30_5356" result="shape" />
                    </filter>
                </defs>
            </svg>
            {isClicked && (
                <div
                    style={{
                        position: "absolute",
                        bottom: "20px",
                        left: "50%",
                        transform: "translate(-60% 60%)",
                        backgroundColor: "#10253D",
                        padding: "5px 0px 10px 20px",
                        borderRadius: "5px",
                        zIndex: 100,
                        boxShadow: "0px 0px 10px rgba(0,0,0,0.1)",
                    }}
                >

                    {event.events.lock_rope_pull_out &&
                        <div className="flex w-[200px] justify-start items-center mt-4 mb-2">
                            <div className="w-[30px]">
                                <img
                                    alt=''
                                    src='/assets/icons/orders/events/unlock.svg'
                                    className="mx-auto"
                                />
                            </div>
                            <div className="ms-2">
                                <p className="text-sm text-white opacity-90">Rope pulled out</p>
                            </div>
                        </div>
                    }

                    {event.events.lock_rope_pull_out === false &&
                        <div className="flex w-[200px] justify-start items-center mt-4 mb-2">
                            <div className="w-[30px]">
                                <img
                                    alt=''
                                    src='/assets/icons/orders/events/lock.svg'
                                    className="mx-auto"
                                />
                            </div>
                            <div className="ms-2">
                                <p className="text-sm text-white opacity-90">Rope inserted</p>
                            </div>
                        </div>
                    }

                    {event.events.rope_cut_alarm &&
                        <div className="flex w-[200px] justify-start items-center mt-4 mb-2">
                            <div className="w-[30px]">
                                <img
                                    alt=''
                                    src={Danger}
                                    className="mx-auto"
                                />
                            </div>
                            <div className="ms-2">
                                <p className="text-sm text-white opacity-90">Rope cut</p>
                            </div>
                        </div>
                    }

                    {event.events.back_cover_opened_alarm &&
                        <div className="flex w-[200px] justify-start items-center mt-4 mb-2">
                            <div className="w-[30px]">
                                <img
                                    alt=''
                                    src={Success}
                                    className="mx-auto"
                                />
                            </div>
                            <div className="ms-2">
                                <p className="text-sm text-white opacity-90">Back cover opened</p>
                            </div>
                        </div>
                    }


                    {event.events.swipe_rfid_card &&
                        <div className="flex w-[200px] justify-start items-center mt-4 mb-2">
                            <div className="w-[30px]">
                                <img
                                    alt=''
                                    src={event.events.swipe_rfid_card === 'illegal_swipe' || event.events.swipe_rfid_card === 'illegal_rfid_card_swipe' ?
                                        Danger :
                                        Success
                                    }
                                    className="mx-auto"
                                />
                            </div>
                            <div className="ms-2">
                                <p className="text-sm text-white opacity-90">{formatString(event.events.swipe_rfid_card)}</p>
                            </div>
                        </div>
                    }
                    {event.events.route_violation &&
                        <div className="flex w-[200px] justify-start items-center mt-4 mb-2">
                            <div className="w-[30px]">
                                <img
                                    alt=''
                                    src={event.events.route_violation === 'no_gps' || event.events.route_violation === 'route_violated' ? Danger : Success}
                                    className="mx-auto"
                                />
                            </div>
                            <div className="ms-2">
                                <p className="text-sm text-white opacity-90">{formatString(event.events.route_violation)}</p>
                            </div>
                        </div>
                    }
                    <div className="flex w-[200px] justify-start items-center mt-4 mb-2">
                        <div className="w-[30px]">
                            <img
                                alt=''
                                src='/assets/icons/orders/events/clock.svg'
                                className="mx-auto"
                            />
                        </div>
                        <div className="ms-2">
                            <p className="text-sm text-white opacity-90">{moment(event?.timestamp).format("DD-MM-YYYY HH:mm:ss") || 'N/A'}</p>
                        </div>
                    </div>

                </div>
            )
            }
        </div >
    );
};
